module.exports = __webpack_public_path__ + "img/bb6.99219c9e.png";